module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stock"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Stock')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-lg btn-menu",
    attrs: {
      "disabled": !_vm.isStockCheckPeriod
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/shop_order_list')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Comfirm Order')))])])]), _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-success btn-lg btn-menu",
    attrs: {
      "to": "/shop_order/history_list"
    }
  }, [_c('i', {
    staticClass: "fa fa-folder-open"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Order History')))])])], 1), _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-info btn-lg btn-menu",
    attrs: {
      "to": "/master_stock"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Master Stock')))])])], 1), _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-lg btn-menu",
    attrs: {
      "to": "/stock_analysis"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Stock Analysis')))])])], 1), _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-danger btn-lg btn-menu",
    attrs: {
      "to": "/master_shop_hold_on_place_list"
    }
  }, [_c('i', {
    staticClass: "fa fa-building"
  }), _c('p', [_vm._v("店舗保管場所毎の"), _c('br'), _c('span', [_vm._v("消耗品一覧")])])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ba1147a0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/stock.pug
// module id = 910
// module chunks = 1